// ProjectCards.jsx
import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

import PlyrPlayer from "./PlyrPlayer";

// 引入图标资源
import aeLogo  from "../../Assets/tool/ae.png";
import prLogo  from "../../Assets/tool/pr.png";
import auLogo  from "../../Assets/tool/au.png";
import meLogo  from "../../Assets/tool/me.png";
import psLogo  from "../../Assets/tool/ps.png";
import c4dLogo from "../../Assets/tool/c4d.png";
import aiLogo  from "../../Assets/tool/ai.png";
import dLogo   from "../../Assets/tool/d.png";
import jLogo   from "../../Assets/tool/f.png";
import fLogo   from "../../Assets/tool/j.png";

import gptLogo  from "../../Assets/tool/gpt.png";
import dallLogo  from "../../Assets/tool/dall.png";
import mjLogo  from "../../Assets/tool/mj.png";
import cuiLogo  from "../../Assets/tool/cui.png";
import sdLogo  from "../../Assets/tool/sd.png";
import runLogo from "../../Assets/tool/run.png";
import elLogo  from "../../Assets/tool/el.png";
import jmLogo   from "../../Assets/tool/jm.png";

import a7m4Logo  from "../../Assets/tool/a7m4.png";
import acLogo  from "../../Assets/tool/ac.png";
import mini4Logo  from "../../Assets/tool/mini4.png";
import wenLogo  from "../../Assets/tool/wen.png";

// 工具图标映射表
const toolIconMap = {
  "Adobe After Effects": aeLogo,
  "Adobe Premiere Pro": prLogo,
  "Adobe Audition": auLogo,
  "Adobe Media Encoder": meLogo,
  "Adobe Photoshop": psLogo,
  "Cinema 4D": c4dLogo,
  "Adobe Illustrator": aiLogo,
  "DaVinci Resolve": dLogo,
  "Final Cut Pro": jLogo,
  "剪映": fLogo,
  "ChatGPT": gptLogo,
  "DALL·E（OpenAI）": dallLogo,
  "Midjourney": mjLogo,
  "ComfyUI": cuiLogo,
  "Stable Diffusion": sdLogo,
  "Runway ML": runLogo,
  "ElevenLabs": elLogo,
  "即梦AI": jmLogo,

  "Sony A7M4":a7m4Logo,
  "DJI Action3":acLogo,
  "DJI Mini4Pro":mini4Logo,
  "DJI RS3":wenLogo,
};

// 渲染工具图标
function renderToolIcon(toolName) {
  const icon = toolIconMap[toolName];
  if (!icon) return <span style={{ marginRight: "8px" }}>{toolName}</span>;

  return (
    <img
      src={icon}
      alt={toolName}
      title={toolName}
      className="project-tool-icon"
    />
  );
}

function ProjectCards({ videoSrc, poster, title, tools, description, demoLink, ghLink, disabled }) {

  return (
    <Card className="project-card-view" style={{ marginBottom: "20px" }}>
      <PlyrPlayer videoSrc={videoSrc} poster={poster} />

      <Card.Body>
        <Card.Title
          style={{
            fontSize: "1.5rem",      // 标题字号大一些
            marginBottom: "24px",    // 标题和正文内容间距加宽
            fontWeight: "400",
          }}
        >
          {title}
        </Card.Title>

        <Card.Text
          style={{
            textAlign: "left",
            lineHeight: 1.8,         // 整体行间距稍微紧凑一点
            fontSize: "1.1rem",          // 正文字体大小
            letterSpacing: "0.05em",     // 字间距
            marginBottom: "30px",    // 给按钮留空间
          }}
        >
          {description?.intro && (
            <p style={{ marginBottom: "6px" }}>
              简介：{description.intro}
            </p>
          )}
          {description?.style && (
            <p style={{ marginBottom: "6px" }}>
              风格： {description.style}
            </p>
          )}
          {tools && tools.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "0px",
                marginTop: 10,
                lineHeight: 0,   // 行间距紧凑
              }}
            >
              软件/工具： 
              {tools.map((tool, idx) => (
                <span key={idx}> {renderToolIcon(tool)} </span>
              ))}
            </div>
          )}
        </Card.Text>

        {demoLink && (
          <Button
            variant={disabled ? "secondary" : "primary"}
            href={disabled ? undefined : demoLink}
            target={disabled ? undefined : "_blank"}
            rel={disabled ? undefined : "noreferrer"}
            disabled={disabled}
            style={{ marginTop: "10px", cursor: disabled ? "not-allowed" : "pointer" }}
          >
            <CgWebsite /> &nbsp; 查看发布账号
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;